import type { SessionClockUpdate } from '@socialgoodsoftware/components';

/** What the server said about this session on the response that just landed. */
type SessionActivity = SessionClockUpdate;

type SessionActivityListener = (activity: SessionActivity) => void;

const listeners = new Set<SessionActivityListener>();

/** Every authenticated request answers the row's remaining time, so the local clock follows the server. */
function notifySessionActivity(activity: SessionActivity = {}): void {
  for (const listener of listeners) {
    listener(activity);
  }
}

function subscribeToSessionActivity(listener: SessionActivityListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export { notifySessionActivity, subscribeToSessionActivity };
export type { SessionActivity };
